import { NgModule } from '@angular/core';
import { RouterModule }   from '@angular/router';

import { AuthGuard } from '../guards/auth-guard';
import { MesaGuard } from '../guards/mesa-guard';
import { LoginGuard } from '../guards/login/login.guard';

import { AppComponent } from '../app.component';
import { AgendaComponent } from '../components/agenda/agenda/agenda.component';
import { LoginComponent } from '../components/login/login.component';
import { CuentasComponent } from '../components/cuentas/cuentas/cuentas.component';
import { ActividadComponent } from '../components/actividad/actividad/actividad.component';
import { ConfiguracionComponent } from '../components/configuracion/configuracion.component';
import { DashboardComponent } from '../components/dashboard/dashboard.component';
import { NegociosHeaderComponent } from '../components/negocios/header/negocios-header.component';
import { NegociosComponent } from '../components/negocios/negocios/negocios.component';
import { NegocioDetailComponent } from '../components/negocios/negocio-detail/negocio-detail.component';
import { ConsignaDetailComponent } from '../components/agenda/consigna-detail/consigna-detail.component';
import { ContactoDetailComponent } from '../components/cuentas/contacto-detail/contacto-detail.component';
import { CuentaDetailComponent } from '../components/cuentas/cuenta-detail/cuenta-detail.component';
import { ColaboradorDetailComponent } from '../components/colaboradores/colaborador-detail/colaborador-detail.component';
import {
  BuscadorComponent,
  ABMComponent,
  RolDetailComponent,
  AcopioDetailComponent,
  CategoriaDetailComponent,
  EditUsuarioComponent,
  UsuarioAgroDetailComponent,
  ComunicacionesComponent,
} from '../components';
import { PerfilComponent } from '../components/perfil/perfil.component';
import { ComunicacionDetailComponent } from '../components/comunicaciones/comunicacion-detail';
import { PermisosDetailComponent } from '../components/abm/permisos-detail/permisos-detail.component';
import { AdministracionHeaderComponent } from '../components/administracion/administracion-header/administracion-header.component';
import * as agris from '../components/agris'
import {IndicadoresGuard} from '../guards/indicadores-guard';
import * as precios from '../components/precios-seccion'
import * as remitos from '../components/administracion/remitos';

export const PATH_DASHBOARD_VIEJO = 'dashboard-viejo';
export const PATH_LOGIN = 'login';
export const PATH_CONSIGNA_DETAIL = 'consigna';
export const PATH_CUENTAS = 'cuentas';
export const PATH_CUENTA_DETAIL = 'indicadores/radiografia';
export const PATH_CONTACTO_DETAIL = 'contacto';
export const PATH_COLABORADOR_DETAIL = 'colaborador';
export const PATH_ACTIVIDAD = 'actividad';
export const PATH_AGENDA = 'agenda';
export const PATH_CONFIGURACION = 'configuracion';
export const PATH_BUSCADOR = 'buscador';
export const PATH_BUSCADOR_CONSIGNAS = 'consignas';
export const PATH_BUSCADOR_COLABORADORES = 'colaboradores';
export const PATH_BUSCADOR_CUENTAS = 'cuentas';
export const PATH_ABM = 'abm';
export const PATH_ABM_ROL_DETAIL = 'rol';
export const PATH_ABM_NUEVO_ROL = 'nuevo-rol';
export const PATH_ABM_ACOPIO_DETAIL = 'acopio';
export const PATH_ABM_CATEGORIA_DETAIL = 'categoria';
export const PATH_USER_PROFILE = 'miperfil';
export const PATH_NEGOCIOS = 'negocios';
export const PATH_NEGOCIO_DETAIL = 'negocio';
export const PATH_PRECIOS = 'visor-precios';
export const PATH_NEW_PRECIO = 'cargar-precio';
export const PATH_COMUNICACION_DETAIL = 'comunicacion';
export const PATH_VALIDATE_PRECIO = 'validar-precio';
export const PATH_PIZARRA = 'pizarra';
export const PATH_VALIDATE_PIZARRA = 'validar-pizarra';
export const PATH_NEW_PRECIO_PIZARRA = 'cargar-precio-pizarra';
export const PATH_PERMISO_DETAIL = 'permiso';
export const PATH_NEW_PERMISO = 'nuevo-permiso';
export const PATH_FINANCIERA = 'financiera';
export const PATH_NEW_PRECIO_FINANCIERA = 'cargar-precio-fianciera';
export const PATH_VALIDATE_PRECIO_FINANCIERA = 'validar-precio-fianciera';
export const PATH_ADMINISTRACION = 'administracion';
export const PATH_EDITAR_USUARIO_AGRO = 'editar-usuario-agro';
export const PATH_DETALLE_USUARIO_AGRO = 'detalle-usuario-agro';
export const PATH_AGRIS_HOME = 'agris';
export const PATH_AGRIS_BUSCADOR = 'agris-buscar';
export const PATH_AGRIS_DETALLE_INSUMO = 'agris-insumo';
export const PATH_AGRIS_NUEVA_COTIZACION = 'agris-nueva-cotizacion';
export const PATH_AGRIS_COTIZACION_DETALLE = 'agris-cotizacion';
export const PATH_AGRIS_COTIZACION_LISTA = 'agris-lista-cotizaciones';
export const PATH_COMUNICADOS = 'comunicados';
export const PATH_PIPELINE = 'pipeline';
export const PATH_DASHBOARD = 'dashboard';
export const PATH_REMITO_DETAIL = 'remito';
export const PATH_REMITO_GENERAR = 'remito-generar';
export const PATH_CREDITOS = 'saf-creditos';
export const PATH_MERCADO_AGD = 'mercado-agd';
export const PATH_DOLAR = 'dolar';
export const PATH_GRANOS_BASE_NEW = 'granos';
export const PATH_NEGOCIOS_NEW = 'negocios';
export const PATH_TABLERO = 'tablero';
export const PATH_BANNERS = 'mkt-cloud';
export const PATH_CLIENTES = 'clientes';
export const PATH_CLIENTES_ACOPIO = 'acopio';

export const routes = [
  { path: '', component: NegociosHeaderComponent, pathMatch: 'full', canActivate: [IndicadoresGuard]},
  { path: PATH_LOGIN, component: LoginComponent, canActivate: [LoginGuard] },
  { path: `${PATH_CONSIGNA_DETAIL}/:id`, component: ConsignaDetailComponent, canActivate: [AuthGuard] },
  { path: PATH_DASHBOARD_VIEJO, component: DashboardComponent, canActivate: [AuthGuard] },
  { path: PATH_NEGOCIOS, component: NegociosHeaderComponent, canActivate: [AuthGuard] },
  { path: PATH_PRECIOS, component: precios.PreciosHeaderComponent, canActivate: [AuthGuard] },
  { path: `${PATH_NEGOCIO_DETAIL}/:id`, component: NegocioDetailComponent, canActivate: [AuthGuard] },
  { path: PATH_NEW_PRECIO, component: precios.NewPrecioComponent, canActivate: [AuthGuard] },
  // { path: PATH_CUENTAS, component: CuentasComponent, canActivate: [AuthGuard] },
  // { path: `${PATH_CUENTAS}/:page`, component: CuentasComponent, canActivate: [AuthGuard] },
  // { path: `${PATH_CUENTA_DETAIL}/:id`, component: CuentaDetailComponent, canActivate: [AuthGuard] },
  // { path: `${PATH_CUENTA_DETAIL}/:id/:page`, component: CuentaDetailComponent, canActivate: [AuthGuard] },
  // { path: `${PATH_CONTACTO_DETAIL}/:id`, component: ContactoDetailComponent, canActivate: [AuthGuard] },
  { path: `${PATH_COLABORADOR_DETAIL}/:id`, component: ColaboradorDetailComponent, canActivate: [AuthGuard] },
  { path: PATH_CONFIGURACION, component: ConfiguracionComponent, canActivate: [AuthGuard] },
  { path: PATH_AGENDA, component: ActividadComponent, canActivate: [AuthGuard]},
  { path: `${PATH_AGENDA}/:page`, component: ActividadComponent, canActivate: [AuthGuard]},
  { path: PATH_BUSCADOR, component: BuscadorComponent, canActivate: [AuthGuard]},
  { path: `${PATH_BUSCADOR}/:page`, component: BuscadorComponent, canActivate: [AuthGuard]},
  { path: PATH_ABM, component: ABMComponent, canActivate: [AuthGuard]},
  { path: `${PATH_ABM}/:page`, component: ABMComponent, canActivate: [AuthGuard] },
  { path: `${PATH_ABM_ROL_DETAIL}/:id`, component: RolDetailComponent, canActivate: [AuthGuard]},
  { path: PATH_ABM_NUEVO_ROL, component: RolDetailComponent, canActivate: [AuthGuard]},
  { path: `${PATH_ABM_ACOPIO_DETAIL}/:id`, component: AcopioDetailComponent, canActivate: [AuthGuard]},
  { path: `${PATH_ABM_ACOPIO_DETAIL}`, component: AcopioDetailComponent, canActivate: [AuthGuard]},
  { path: `${PATH_ABM_CATEGORIA_DETAIL}/:id`, component: CategoriaDetailComponent, canActivate: [AuthGuard]},
  { path: `${PATH_ABM_CATEGORIA_DETAIL}`, component: CategoriaDetailComponent, canActivate: [AuthGuard]},
  { path: PATH_USER_PROFILE, component: PerfilComponent, canActivate: [AuthGuard]},
  { path: PATH_COMUNICADOS, component: ComunicacionesComponent, canActivate: [AuthGuard]},
  { path: `${PATH_COMUNICACION_DETAIL}/:id`, component: ComunicacionDetailComponent, canActivate: [AuthGuard]},
  { path: `${PATH_VALIDATE_PRECIO}`, component: precios.ValidatePrecioComponent, canActivate: [AuthGuard]},
  { path: PATH_PIZARRA, component: precios.PreciosHeaderComponent, canActivate: [AuthGuard] },
  { path: `${PATH_VALIDATE_PIZARRA}`, component: precios.ValidatePrecioComponent, canActivate: [AuthGuard]},
  { path: PATH_NEW_PRECIO_PIZARRA, component: precios.NewPrecioPizarraComponent, canActivate: [AuthGuard] },
  { path: `${PATH_NEGOCIOS}/:page`, component: NegociosHeaderComponent, canActivate: [AuthGuard] },
  { path: `${PATH_PERMISO_DETAIL}/:id`, component: PermisosDetailComponent, canActivate: [AuthGuard] },
  { path: PATH_NEW_PERMISO, component: PermisosDetailComponent, canActivate: [AuthGuard] },
  { path: PATH_FINANCIERA, component: precios.PreciosHeaderComponent, canActivate: [AuthGuard] },
  { path: PATH_NEW_PRECIO_FINANCIERA, component: precios.NewPrecioFinancieraComponent, canActivate: [AuthGuard] },
  { path: PATH_VALIDATE_PRECIO_FINANCIERA, component: precios.ValidatePrecioFinancieraComponent, canActivate: [AuthGuard] },
  { path: PATH_ADMINISTRACION, component: AdministracionHeaderComponent, canActivate: [AuthGuard] },
  { path: `${PATH_ADMINISTRACION}/:page`, component: AdministracionHeaderComponent, canActivate: [AuthGuard] },
  // { path: `${PATH_EDITAR_USUARIO_AGRO}/:id`, component: EditUsuarioComponent, canActivate: [AuthGuard] },
  // { path: `${PATH_DETALLE_USUARIO_AGRO}/:id`, component: UsuarioAgroDetailComponent, canActivate: [AuthGuard] },
  /*
  { path: PATH_AGRIS_HOME, component: agris.AgrisHomePageComponent, canActivate: [AuthGuard] },
  { path: PATH_AGRIS_BUSCADOR, component: agris.AgrisBuscadorPageComponent, canActivate: [AuthGuard] },
  { path: `${PATH_AGRIS_BUSCADOR}/:search`, component: agris.AgrisBuscadorPageComponent, canActivate: [AuthGuard] },
  { path: `${PATH_AGRIS_DETALLE_INSUMO}/:id`, component: agris.AgrisDetalleInsumoPageComponent, canActivate: [AuthGuard] },
  { path: PATH_AGRIS_NUEVA_COTIZACION, component: agris.AgrisNuevaCotizacionPageComponent, canActivate: [AuthGuard] },
  { path: `${PATH_AGRIS_COTIZACION_DETALLE}/:id`, component: agris.AgrisCotizacionDetallePageComponent, canActivate: [AuthGuard] },
  { path: PATH_AGRIS_COTIZACION_LISTA, component: agris.AgrisListaCotizacionesPageComponent, canActivate: [AuthGuard] },
  */
  { path: PATH_PIPELINE, component: NegociosHeaderComponent, canActivate: [AuthGuard] },
  { path: PATH_DASHBOARD, component: NegociosHeaderComponent, canActivate: [AuthGuard] },
  { path: `${PATH_REMITO_DETAIL}/:id`, component: remitos.RemitosDetailPageComponent, canActivate: [AuthGuard] },
  { path: PATH_REMITO_GENERAR, component: remitos.RemitosGenerarPageComponent, canActivate: [AuthGuard] },

  { path: '**', component: NegociosHeaderComponent, canActivate: [IndicadoresGuard]}

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  providers: [
    AuthGuard,
    MesaGuard,
    IndicadoresGuard,
    LoginGuard,
  ],
  exports: [ RouterModule ]
})
export class NavigationModule {

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/navigation/navigation.module.ts